import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import PricingSelection from 'components/pricing/PricingSelectionComponent'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class AddNewCycleModal extends React.Component {
  static propTypes = {
    transaction: PropTypes.object.isRequired,
    pricings: PropTypes.array.isRequired,
    currentPricing: PropTypes.object.isRequired,
    createCycle: PropTypes.func.isRequired
  }
  state = {
    pricing: null
  }
  handleCreateCycle = () => {
    const { transaction } = this.props
    const { pricing } = this.state
    this.props.createCycle(transaction, pricing)
  }
  handlePricingChange = pricing => {
    this.setState({ pricing: pricing })
  }
  componentDidMount() {
    if (this.props.currentPricing) {
      this.setState({ pricing: this.props.currentPricing })
    }
  }
  render() {
    const { pricings } = this.props
    const { pricing } = this.state
    return (
      <ModalWrapper
        appBar
        open
        onOk={this.handleCreateCycle}
        title={`Ajouter un cycle`}
        showOk>
        <Grid container direction="row" justify="center">
          <Grid item xs={12}>
            <Typography variant="title" gutterBottom>
              {' '}
              Choix du tarif{' '}
            </Typography>
            <Divider />
          </Grid>
          <PricingSelection
            selectedPricing={pricing}
            pricings={pricings}
            onChange={this.handlePricingChange}
          />
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(AddNewCycleModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/AddNewCycleModal.js